"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const semantic_json_1 = require("@hediet/semantic-json");
class ParamType {
    get T() {
        throw new Error();
    }
    withDefaultValue(defaultValue) {
        return new TypeWithDefaultValue(this, defaultValue);
    }
    getRealType() {
        return this;
    }
    itemToString() {
        return this.toString();
    }
}
exports.ParamType = ParamType;
class TypeWithDefaultValue {
    constructor(type, defaultValue) {
        this.type = type;
        this.defaultValue = defaultValue;
        this.kind = "TypeWithDefaultValue";
    }
    get T() {
        throw new Error();
    }
    getRealType() {
        return this.type;
    }
    toString() {
        return this.type.toString();
    }
    itemToString() {
        return this.type.itemToString();
    }
    get serializer() {
        return this.type.serializer;
    }
}
exports.TypeWithDefaultValue = TypeWithDefaultValue;
class NoValueParamType extends ParamType {
    constructor() {
        super(...arguments);
        this.kind = "NoValue";
    }
    parseStrings(values) {
        return { result: this.parse() };
    }
}
exports.NoValueParamType = NoValueParamType;
class SingleValueParamType extends ParamType {
    constructor() {
        super(...arguments);
        this.kind = "SingleValue";
    }
    parseStrings(values) {
        return this.parse(values[0]);
    }
}
exports.SingleValueParamType = SingleValueParamType;
class MultiValueParamType extends ParamType {
    constructor() {
        super(...arguments);
        this.kind = "MultiValue";
    }
    parseStrings(values) {
        return this.parse(values);
    }
}
exports.MultiValueParamType = MultiValueParamType;
class TrueParamType extends NoValueParamType {
    parse() {
        return true;
    }
    toString() {
        return "true";
    }
    get serializer() {
        return semantic_json_1.sLiteral(true);
    }
}
exports.TrueParamType = TrueParamType;
class StringSerializerParamType extends SingleValueParamType {
    constructor(serializer) {
        super();
        this.serializer = serializer;
    }
    parse(value) {
        const r = this.serializer.deserializeTyped(value);
        if (r.isOk) {
            return { result: r.value };
        }
        else {
            const message = r.errors.map(e => e.message).join("\n");
            return { error: { kind: "ArgParseError", message } };
        }
    }
    toString() {
        return this.serializer.toString();
    }
}
exports.StringSerializerParamType = StringSerializerParamType;
class NumberSerializerParamType extends SingleValueParamType {
    constructor(serializer, name) {
        super();
        this.serializer = serializer;
        this.name = name;
    }
    parse(value) {
        const numberVal = parseFloat(value);
        if (Number.isNaN(numberVal)) {
            return {
                error: {
                    kind: "ArgParseError",
                    message: `String "${value}" is not a valid float.`,
                },
            };
        }
        const r = this.serializer.deserializeTyped(numberVal);
        if (r.isOk) {
            return { result: r.value };
        }
        else {
            const message = r.errors.map(e => e.message).join("\n");
            return { error: { kind: "ArgParseError", message } };
        }
    }
    toString() {
        return this.name;
    }
}
exports.NumberSerializerParamType = NumberSerializerParamType;
class StringParamType extends SingleValueParamType {
    parse(value) {
        return { result: value };
    }
    toString() {
        return "string";
    }
    get serializer() {
        return semantic_json_1.sString;
    }
}
exports.StringParamType = StringParamType;
class ChoiceParamType extends SingleValueParamType {
    constructor(choices) {
        super();
        this.choices = choices;
    }
    parse(value) {
        return { result: value };
    }
    toString() {
        return this.choices.join(" | ");
    }
    get serializer() {
        return semantic_json_1.sString;
    }
}
exports.ChoiceParamType = ChoiceParamType;
class ArrayType extends MultiValueParamType {
    constructor(itemType) {
        super();
        this.itemType = itemType;
    }
    parse(items) {
        const result = new Array();
        for (const i of items) {
            const r = this.itemType.parse(i);
            if ("result" in r) {
                result.push(r.result);
            }
            else {
                return r;
            }
        }
        return { result };
    }
    toString() {
        return `${this.itemType.toString()}[]`;
    }
    itemToString() {
        return this.itemType.toString();
    }
    get serializer() {
        return semantic_json_1.sArray(this.itemType.serializer);
    }
}
exports.ArrayType = ArrayType;
exports.types = {
    booleanFlag: new TrueParamType().withDefaultValue(false),
    int: new NumberSerializerParamType(semantic_json_1.sNumber, "int"),
    number: new NumberSerializerParamType(semantic_json_1.sNumber, "number"),
    string: new StringParamType(),
    choice: (...choices) => new ChoiceParamType(choices),
    arrayOf: (itemType) => new ArrayType(itemType),
};
//# sourceMappingURL=param-types.js.map